<template>
  <div style="height: 100%">
    <div v-if="enableClientSearch" style="padding: 4px 2px;">
      <slot name="clientSearch">
        <Input v-model="searchText" search :enter-button="searchButtonText" :placeholder="searchPlaceholder" @on-search="onSearchTable" />
      </slot>
    </div>
    <Table :style="{ minHeight: tableMinHeight + 'px'}" class="full-height"
           :columns="columns"
           :data="insideData"
           :show-header="false"
           :highlight-row="true"
           :tooltip="true"
           size="small"
           @on-current-change="onCurrentChange($event)"
    >
    </Table>
    <div v-if="!(hidePageForOne && (totalPageSize === 1))" class="left-side-page-wrapper">
      <ButtonGroup style="width: 100%">
        <Button :disabled="preBtnDisabled" type="primary" style="width: 30%" @click="onGoToPrePage">
          <Icon type="ios-arrow-back"></Icon>
          {{preBtnText}}
        </Button>
        <Button type="success" style="width: 40%">{{currentPage}}/{{totalPageSize}}</Button>
        <Button :disabled="nextBtnDisabled" type="primary" style="width: 30%" @click="onGoToNextPage">
          {{nextBtnText}}
          <Icon type="ios-arrow-forward"></Icon>
        </Button>
      </ButtonGroup>
    </div>
  </div>
</template>

<script>
import { deepCopy } from './../../utils/assist.js'
import expandRow from '../table-expand/table-expand'
export default {
  name: 'left-slider',
  components: { expandRow },
  props: {
    tableMinHeight: {
      type: Number,
      default: 200
    },
    enableClientSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: '输入内容搜索'
    },
    searchButtonText: {
      type: String,
      default: '搜索'
    },
    clientSidePage: {
      type: Boolean,
      default: false
    },
    leftRenderColumn: {
      type: Array,
      default () {
        return []
      }
    },
    leftRenderData: {
      type: Array,
      default () {
        return []
      }
    },
    expand: {
      type: Boolean,
      default: true
    },
    preBtnText: {
      type: String,
      default: '往前'
    },
    nextBtnText: {
      type: String,
      default: '往后'
    },
    totalCount: {
      type: Number,
      default: 0
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    defaultPageSize: {
      type: Number,
      default: 20
    },
    hidePageForOne: {
      type: Boolean,
      default: false
    },
    /** 函数回调 **/
    queryDataCallBack: {
      type: Function,
      default () {
        return []
      }
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default () {
        return ''
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    showSizer: {
      type: Boolean,
      default: true
    },
    useDefaultFilter: {
      type: Boolean,
      default: true
    },
    customerSearchFilter: {
      type: Function,
      default () {
        return true
      }
    },
    searchBtnClickCallBack: {
      type: Function,
      default () {
      }
    }
  },
  data () {
    return {
      searchText: '',
      tempTotalData: [],
      expandRenderColumn: [
      ],
      columns: [],
      insideData: [],
      insideTotalCount: 0,
      currentPage: 1,
      totalPageSize: 0,
      pageSize: 15,
      preBtnDisabled: false,
      nextBtnDisabled: false
    }
  },
  computed: {
    allPages () {
      const allPage = Math.ceil(this.insideTotalCount / this.defaultPageSize)
      return (allPage === 0) ? 1 : allPage
    }
  },
  watch: {
    leftRenderColumn (val) {
      this.initRenderColumns()
    },
    pageIndex (val) {
      if (!this.clientSidePage) {
        this.currentPage = val
      }
    },
    totalCount (val) {
      if (!this.clientSidePage) {
        this.insideTotalCount = val
        this.computedPageSize()
      }
    },
    defaultPageSize (val) {
      this.pageSize = val
      this.computedPageSize()
    },
    leftRenderData (val) {
      if (this.clientSidePage) {
        this.insideTotalCount = this.leftRenderData.length
        this.computedPageSize()
      }
      this.tempTotalData = val
      this.handClientSidePageData()
    }
  },
  methods: {
    onSearchTable (searchText) {
      if (this.clientSidePage) {
        this.handClientSideSearch()
        this.handClientSidePageData()
      } else {
        this.searchBtnClickCallBack(this.searchText)
        this.queryDataCallBack()
      }
    },
    handClientSidePageData () {
      this.insideData = []
      if (this.tempTotalData.length > 0) {
        this.insideTotalCount = this.tempTotalData.length
        let totalPage = Math.ceil(this.insideTotalCount / this.pageSize)
        if (this.currentPage > totalPage) {
          this.currentPage = totalPage
        }
        let startIndex = (this.currentPage - 1) * this.pageSize
        let endIndex = this.currentPage * this.pageSize
        if (endIndex > this.tempTotalData.length) {
          endIndex = this.tempTotalData.length
        }
        for (let i = startIndex; i < endIndex; i++) {
          this.insideData.push(deepCopy(this.tempTotalData[i]))
        }
      }
    },
    handClientSideSearch () {
      this.tempTotalData = []
      if (this.leftRenderData.length > 0) {
        let reg = new RegExp(this.escapeHTML(this.searchText.trim()))
        let field = ''
        for (let i = 0; i < this.leftRenderData.length; i++) {
          if (this.useDefaultFilter) {
            if (this.searchText.trim() !== '') {
              for (let j = 0; j < this.leftRenderColumn.length; j++) {
                if (this.leftRenderColumn[j].key !== 'handle') {
                  field = this.leftRenderData[i][this.leftRenderColumn[j].key] + ''
                  if ((field).match(reg)) {
                    this.tempTotalData.push(deepCopy(this.leftRenderData[i]))
                    break
                  }
                }
              }
            } else {
              this.tempTotalData.push(deepCopy(this.leftRenderData[i]))
            }
          } else {
            if (this.customerSearchFilter(this.leftRenderData[i], i)) {
              this.tempTotalData.push(deepCopy(this.leftRenderData[i]))
            }
          }
        }
      }
    },
    escapeHTML (text) {
      if (typeof text === 'string') {
        return text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
          .replace(/`/g, '&#x60;')
      }
      return text
    },
    onGoToPrePage () {
      if (this.currentPage <= 1) {
        return
      }
      this.currentPage--
      if (this.currentPage === 1) {
        this.preBtnDisabled = true
      }
      if (this.nextBtnDisabled) {
        this.nextBtnDisabled = false
      }
      if (this.clientSidePage) {
        this.handClientSidePageData()
      } else {
        this.queryDataCallBack(this.currentPage, this.pageSize)
      }
    },
    onGoToNextPage () {
      if (this.currentPage >= this.totalPageSize) {
        return
      }
      this.currentPage++
      if (this.currentPage === this.totalPageSize) {
        this.nextBtnDisabled = true
      }
      if (this.preBtnDisabled) {
        this.preBtnDisabled = false
      }
      if (this.clientSidePage) {
        this.handClientSidePageData()
      } else {
        this.queryDataCallBack(this.currentPage, this.pageSize)
      }
    },
    computedPageSize () {
      let currentPageSize = Math.ceil(this.insideTotalCount / this.pageSize)
      this.totalPageSize = (currentPageSize === 0) ? 1 : currentPageSize
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    initRenderColumns () {
      this.columns = []
      this.expandRenderColumn = []
      if (this.leftRenderColumn && this.leftRenderColumn.length > 0) {
        this.leftRenderColumn.forEach(item => {
          if (item.expand) {
            this.expandRenderColumn.push(item)
          }
          if (item.list) {
            this.columns.push(item)
          }
        })
        if (this.expand) {
          this.columns.push({
            type: 'expand',
            width: 50,
            render: (h, params) => {
              return h(expandRow, {
                props: {
                  row: params.row,
                  renderColumn: this.expandRenderColumn
                }
              })
            }
          })
        }
      }
    }
  },
  mounted () {
    this.initRenderColumns()
    if (!this.clientSidePage) {
      this.insideTotalCount = this.totalCount
    } else {
      this.insideTotalCount = this.leftRenderData.length
    }
    this.currentPage = this.pageIndex
    this.pageSize = this.defaultPageSize
    this.tempTotalData = this.leftRenderData
    this.queryDataCallBack(this.currentPage, this.pageSize)
    this.computedPageSize()
    if (this.clientSidePage) {
      this.handClientSideSearch()
    }
    this.handClientSidePageData()
  }
}
</script>

<style scoped>
  .ivu-table .demo-table-info-row td{
    background-color: #2db7f5;
    color: #fff;
  }
  .ivu-table-row .demo-table-error-row td{
    background-color: #ff6600;
    color: #fff;
  }
  .ivu-table-row-highlight td {
    background-color: #ff6600!important;
  }
  .left-side-page-wrapper {
    margin-top: 8px;
    text-align: center;
    width: 100%;
  }
</style>
